// removed by extract-text-webpack-plugin
module.exports = {"import-button-wrapper":"import-button-wrapper","importButtonWrapper":"import-button-wrapper","import-link-wrapper":"import-link-wrapper","importLinkWrapper":"import-link-wrapper"};


//////////////////
// WEBPACK FOOTER
// ./src/components/users/directoryUsers/importUserButton/style.scss
// module id = 1505
// module chunks = 0